import { render, staticRenderFns } from "./PaintFinishTab.vue?vue&type=template&id=43865b84&scoped=true&"
import script from "./PaintFinishTab.vue?vue&type=script&lang=js&"
export * from "./PaintFinishTab.vue?vue&type=script&lang=js&"
import style0 from "./PaintFinishTab.vue?vue&type=style&index=0&id=43865b84&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43865b84",
  null
  
)

export default component.exports